// extracted by mini-css-extract-plugin
export default {"close-button":"CloseButton_close-button__OVg4D","close-button__wrapper":"CloseButton_close-button__wrapper__Z+Uko","close-button__icon":"CloseButton_close-button__icon__Tz1fm"};